var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62854 7.11428H3.42855V8.31427H4.62854V7.11428Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 7.11428H5.4V8.31427H6.6V7.11428Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37146 7.11428H8.57145V8.31427H7.37146V7.11428Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71427 0H2.91427V1.71427H5.4V0H6.6V1.71427H9.08574V0H10.2857V1.71427H11.1428C11.1905 1.71427 11.2374 1.71818 11.283 1.72568C11.3208 1.7182 11.36 1.71427 11.4 1.71427C11.7314 1.71427 12 1.9829 12 2.31427V11.3999C12 11.7313 11.7314 11.9999 11.4 11.9999L11.3949 11.9999H0.605099L0.599996 11.9999C0.268627 11.9999 0 11.7313 0 11.3999V2.31427C0 1.9829 0.268627 1.71427 0.599996 1.71427C0.640032 1.71427 0.679152 1.71819 0.716993 1.72567C0.762595 1.71817 0.809411 1.71427 0.857137 1.71427H1.71427V0ZM10.8 5.14282H1.19999V10.7999H10.8V5.14282Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar_outline.66f6550e.svg";
export { ForwardRef as ReactComponent };